/* ============
 * Organization Conf Mutations
 * ============
 *
 * The mutations available for the organization conf module.
 */

import {
  CONF,
  DOC_TYPES,
  ADD_PARSER,
  UPDATE_PARSERS,
  REMOVE_PARSER,
  UPDATE_EXTRA_OPTIONS,
  ADD_DOCTYPES_WITHSTORAGE,
  REMOVE_DOCTYPES_WITHSTORAGE, UPDATE_DISPATCH_VALIDATION,
  UPDATE_PRINTING_INFOS,
} from './mutation-types';

export default {
  /**
   * Mutation to update the store with the fetched configuration.
   *
   * @param {Object} state      The current state of the store.
   * @param {Object}  conf     The fetched configuration.
   */
  [CONF](state, conf) {
    state.conf = conf;
  },

  /**
   * Mutation to update the store with the fetched docTypes.
   *
   * @param {Object} state      The current state of the store.
   * @param {Object}  docTypes     The fetched docTypes.
   */
  [DOC_TYPES](state, docTypes) {
    state.docTypes = docTypes;
  },

  /**
   * Mutation which will add a new parser.
   *
   * @param {Object} state The current state of the store.
   * @param {Object} parser The newly added parser.
   */
  [ADD_PARSER](state, parser) {
    // eslint-disable-next-line
    const index = state.conf.parserInfos.findIndex(item => item.docType === parser.docType);

    if (index >= 0) {
      state.conf.parserInfos[index].metaInfos.push(parser.metaInfos);
    } else {
      const data = {
        docType: parser.docType,
        metaInfos: [parser.metaInfos],
        extraOptions: {},
      };
      state.conf.parserInfos.push(data);
    }
  },

  /**
   * Mutation which will update parsers.
   *
   * @param {Object} state The current state of the store.
   * @param {Object} parsers The parsers.
   */
  [UPDATE_PARSERS](state, parsers) {
    state.conf.parserInfos = parsers;
  },

  /**
   * Mutation which will update parsers.
   *
   * @param {Object} state The current state of the store.
   * @param {Object} extraOptions The extra options.
   */
  [UPDATE_EXTRA_OPTIONS](state, payload) {
    state.conf.extraOptions = payload.extraOptions;
    state.conf.subscribeToSignature = payload.subscribeToSignature;
  },

  /**
   * Mutation which will remove a parser.
   *
   * @param {Object} state The current state of the store.
   * @param {Object} parser The parser which will be removed.
   */
  [REMOVE_PARSER](state, parser) {
    state.conf.parserInfos[parser.parserIndex].metaInfos.splice(parser.metaInfoIndex, 1);
    if (state.conf.parserInfos[parser.parserIndex].metaInfos.length === 0) {
      state.conf.parserInfos.splice(parser.parserIndex, 1);
    }
  },

  /**
   * Mutation which will add a new docTypeWithStorage.
   *
   * @param {Object} state The current state of the store.
   * @param {Object} docTypeWithStorage The newly added docTypeWithStorage.
   */
  [ADD_DOCTYPES_WITHSTORAGE](state, docTypeWithStorage) {
    state.conf.docTypesWithStorage = docTypeWithStorage;
  },

  [UPDATE_PRINTING_INFOS](state, printingInfos) {
    state.conf.printingInfos = printingInfos;
  },

  /**
   * Mutation which will remove a docTypeWithStorage.
   *
   * @param {Object} state The current state of the store.
   * @param {Object} index The index of the docTypeWithStorage which will be removed.
   */
  [REMOVE_DOCTYPES_WITHSTORAGE](state, index) {
    state.conf.docTypesWithStorage.splice(index, 1);
  },

  /**
   * Mutation which will update dispatch validation
   *
   * @param {Object} state The current state of the store.
   * @param {Object} payload The app payload
   */
  [UPDATE_DISPATCH_VALIDATION](state, payload) {
    if (state.conf.dispatchValidation
      .find(item => item.docTypeCode === payload.docTypeCode) !== undefined) {
      state.conf.dispatchValidation.find(item => item.docTypeCode === payload.docTypeCode)
        .validate = payload.validate;
    } else {
      state.conf.dispatchValidation.push({
        docTypeCode: payload.docTypeCode,
        validate: payload.validate,
      });
    }
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/organization-conf/mutations.js